import type { NodeDefinition } from "../domain/types/index.js";

type NodeSpec = Omit<NodeDefinition, "id"> & { id?: never };

function node(id: NodeDefinition["id"], spec: NodeSpec): NodeDefinition {
  return { id, ...spec };
}

function caseNode(
  id: NodeDefinition["id"],
  next: readonly string[],
  x: number,
  y: number,
): NodeDefinition {
  return node(id, { kind: "case", caseId: id, next, x, y });
}

function restNode(
  id: NodeDefinition["id"],
  next: readonly string[],
  x: number,
  y: number,
): NodeDefinition {
  return node(id, { kind: "rest", next, x, y });
}

function eventNode(
  id: NodeDefinition["id"],
  next: readonly string[],
  x: number,
  y: number,
): NodeDefinition {
  return node(id, { kind: "event", next, x, y });
}

// 第5期はイベントの多い繁忙期。
// 導入イベントの直後に休日を置き、悪い結果でも立て直してから本線を選べる。
export const MAP_NODES_PEAK: Record<string, NodeDefinition> = {
  start: node("start", { kind: "start", next: ["e1"], x: 2, y: 0 }),
  e1: caseNode("e1", ["event-e-intro"], 2, 1),
  "event-e-intro": eventNode("event-e-intro", ["rest-e-open"], 2, 2),
  "rest-e-open": restNode("rest-e-open", ["e-l", "e-c", "e-r"], 2, 3),

  "e-l": caseNode("e-l", ["event-e-l"], 0, 4),
  "e-c": caseNode("e-c", ["e-lc", "e-cr"], 2, 5),
  "e-r": caseNode("e-r", ["event-e-r"], 4, 4),
  "event-e-l": eventNode("event-e-l", ["e-l2"], 0, 5),
  "event-e-r": eventNode("event-e-r", ["e-r2"], 4, 5),
  "e-l2": caseNode("e-l2", ["rest-e-l"], 0, 6),
  "e-r2": caseNode("e-r2", ["e-r3"], 4, 6),
  "e-lc": caseNode("e-lc", ["rest-e-l"], 1, 6),
  "e-cr": caseNode("e-cr", ["e-c2", "e-r3"], 3, 6),
  "rest-e-l": restNode("rest-e-l", ["e-l3"], 0, 7),
  "e-r3": caseNode("e-r3", ["event-e-r-mid"], 4, 8),
  "e-l3": caseNode("e-l3", ["rest-e-c"], 1, 8),
  "e-c2": caseNode("e-c2", ["rest-e-c"], 2, 8),
  "rest-e-c": restNode("rest-e-c", ["event-e-mid", "e-xfer"], 2, 9),
  "event-e-r-mid": eventNode("event-e-r-mid", ["e-r4"], 4, 9),
  "event-e-mid": eventNode("event-e-mid", ["e-l4"], 1, 10),
  "e-r4": caseNode("e-r4", ["e-r5"], 4, 10),
  "e-l4": caseNode("e-l4", ["e-l5"], 1, 11),
  "e-xfer": caseNode("e-xfer", ["e-r5"], 3, 10),
  "e-l5": caseNode("e-l5", ["rest-e-late"], 1, 12),
  "e-r5": caseNode("e-r5", ["rest-e-late"], 3, 11),

  "rest-e-late": restNode("rest-e-late", ["e-pre-l", "event-e-pre"], 2, 13),
  "e-pre-l": caseNode("e-pre-l", ["rest-e-pre"], 1, 14),
  "event-e-pre": eventNode("event-e-pre", ["e-pre-r"], 3, 14),
  "e-pre-r": caseNode("e-pre-r", ["rest-e-pre"], 3, 15),
  "rest-e-pre": restNode("rest-e-pre", ["boss"], 2, 16),
  boss: node("boss", { kind: "case", caseId: "peak-boss", next: [], x: 2, y: 17 }),
};
